// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"_n-z","slideIn":"ao-z"};